import { Chip, SxProps, Tooltip } from "@mui/material";
import { useMemo } from "react";

export default function ChipWithTooltip({
    label,
    extraLabels,
    stringPrefix = "",
    quebraLinha = false,
    extraStyles = {},
}: ChipWithTooltipProps) {

    const title = useMemo(() => {
        let result = "";
        for (let i = 0; i < extraLabels.length; i++) {
            if (i > 0) {
                result += quebraLinha ? "<br />" : " • ";
            }
            result += stringPrefix + extraLabels[i];
        }
        return result;
    }, [stringPrefix, extraLabels, quebraLinha])

    return (
        <Tooltip title={<span
         dangerouslySetInnerHTML={{ __html: title }}
         style={{
            maxHeight: extraLabels.length > 20 ? '300px' : 'auto',
            overflowY: extraLabels.length > 20 ? 'auto' : 'hidden',
            display: 'block'
        }}
          />
          }>
            <Chip {...{ label }} size="small" sx={{...extraStyles}} />
        </Tooltip>
    )
}

interface ChipWithTooltipProps {
    label: string
    extraLabels: string[] | number[],
    stringPrefix?: string
    quebraLinha?: boolean
    extraStyles?: SxProps
}